import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { Observable } from 'rxjs';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-adventure-quest-info-modal',
  templateUrl: './adventure-quest-info.component.html',
  styleUrls: ['./adventure-quest-info.component.scss'],
  standalone: true,
  imports: [NavigationButtonComponent, SharedModule],
})
export class AdventureQuestInfoModalComponent {
  adventureQuestInfoModalData = inject<Modal>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);

  componentDestroy: () => Observable<unknown>;

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.adventureQuestInfoModalData.id, ModalType.View, this.adventureQuestInfoModalData)
    );
  }
}
